import { _ as r } from "./main37.js";
var a = r, o = a["__core-js_shared__"], s = o;
export {
  s as _
};
